<!--
* @program: office_automation 
* @author: ly
* @component:AttendanceRecords
* @description: 
* @create: 2022-01-14 17:03
-->
<template>
    <div class="oa-content">
        <div class="oa-window" >
            <div v-if="visible" >
                <a-layout-content style="display: inline-flex;flex-wrap: wrap;">
                    <a-card class="mode">
                        <a-button class="cover" type="primary" @click="comp = 'AttendanceRecordsFromUser'">通过人查询</a-button>
                    </a-card>
                    <a-card class="mode">
                        <a-button class="cover" type="primary" @click="comp = 'AttendanceRecordsFromMonth'">通过时间查询</a-button>
                    </a-card>
                    <a-card class="mode">
                        <a-button class="cover" danger type="primary" @click="modalVisible = true"><template #icon><FolderOpenOutlined/></template>上传考勤记录</a-button>
                    </a-card>
                    <a-card class="mode">
                        <a-button class="cover" type="primary" @click="downLoadFile">下载考勤文件模板</a-button>
                    </a-card>
                </a-layout-content>
            </div>
            <div v-else style="height: 100%">
                <div v-is="comp" style="height: 100%"/>
            </div>
        </div>
    </div>
    <a-modal v-model:visible="modalVisible"
             destroyOnClose
             :footer="null"
             title="选择考勤文件和对应的月份">
        <div class="center-flex">
            <MonthSelector v-model:value="yearMonth" />
            <a-upload :accept="accept"
                      :action="uploadUrl"
                      :data="{yearMonth}"
                      :show-upload-list="false"
                      @change="handleChange"
                      v-model:file-list="fileList"
            >
                <a-tooltip title="上传记录考勤记录的excel文件">
                    <a-button type="primary" danger :loading="loading">
                        <template #icon><FolderOpenOutlined/></template>
                        上传考勤记录
                    </a-button>
                </a-tooltip>
            </a-upload>
        </div>
    </a-modal>
</template>

<script>
    import AttendanceRecordsFromUser from "./AttendanceRecordsFromUser";
    import AttendanceRecordsFromMonth from "./AttendanceRecordsFromMonth";
    import {FolderOpenOutlined} from "@ant-design/icons-vue"
    import attendance from "../../../../assets/api/attendance";
    import MonthSelector from "../../../../components/SearchBar/MonthSelector";
    import moment from "moment";
    export default {
        name: "AttendanceRecords",
        components:{
            AttendanceRecordsFromUser,AttendanceRecordsFromMonth,FolderOpenOutlined,MonthSelector
        },
        computed:{
            visible(){
                return !this.comp;
            }
        },
        data(){
            return{
                comp:null,
                loading:false,
                accept:"application/vnd.ms-excel",
                uploadUrl:attendance.importExcel.url,
                fileList:[],
                yearMonth:null,
                modalVisible:false
            }
        },
        methods:{
            handleChange({file,fileList}){
                if (file.status === 'done') {
                    if(file.response.flag){
                        this.$message.success(file.response.msg);
                    }
                    else{
                        this.$message.error(file.response.msg);
                    }
                }
            },
            downLoadFile(){
                attendance.exportExcel.fileDownloadGet(this,{},"考勤文件模板.xls");
            }
        },
        created() {
            this.yearMonth = moment(new Date().valueOf()).format("YYYY-MM");
        }
    }
</script>

<style scoped>
    .mode{
        width: 15vw;
        height: 10vh;
        margin: 5vw;
        background: #a1a1a1;
    }
    .cover{
        width: 10vw;
        height: 10vh;
        font-size: 20px;
    }
</style>